export enum BLOCKCHAIN_NAME {
  MILKOMEDA = 'milkomeda',
  CARDANO = 'cardano',
  TESTNET_MILKOMEDA = 'testnet_milkomeda',
  TESTNET_CARDANO = 'testnet_cardano',
}
